/* eslint-disable jsx-a11y/label-has-associated-control */
import { SxProps, Theme } from '@mui/material/styles';

interface Props {
  children: React.ReactNode;
  sx: SxProps<Theme>;
}

export const Display1 = ({ children }: any) => (
  <label style={{ fontWeight: '500', fontSize: '80px', lineHeight: '84px' }}>{children}</label>
);
export const Display2 = ({ children }: any) => (
  <label style={{ fontWeight: '500', fontSize: '64px', lineHeight: '68px' }}>{children}</label>
);
export const Display3 = ({ children }: any) => (
  <label style={{ fontWeight: '500', fontSize: '48px', lineHeight: '52px' }}>{children}</label>
);

export const Link = ({ children }: any) => (
  <label
    style={{
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '22px',
      color: '#21B8E8',
      textDecoration: 'underline',
    }}
  >
    {children}
  </label>
);

export const ErrorMessage = ({ children }: any) => (
  <label style={{
    fontWeight: '500', fontSize: '16px', lineHeight: '19px', color: '#E93E3E',
  }}
  >
    {children}
  </label>
);

export const LogoLabel = ({ children }: any) => (
  <label style={{ fontWeight: '500', fontSize: '26px', color: '#FFF' }}>{children}</label>
);
